import ApiFactory from '../api/ApiFactory.js';

const get = (searchObj) => {
  const {resource, custom_action, additional_resources, alias} = searchObj;

  const GetType = custom_action? `GET_${resource}_${custom_action}` : `GET_${resource}`;

  return (dispatch) => {
    dispatch({
      type: GetType,
      data: searchObj
    });
    return ApiFactory.get(searchObj)
    .then(data => {
      dispatch({
        type: `${GetType}_SUCCESS`,
        data: data,
        additional_resources: additional_resources,
        alias
      });
      return data;
    })
    .catch(err => {
      throw(err);
    });
  };
};

const select = (resource, record) => {

  return (dispatch) => {
    dispatch({
      type: `SELECT_${resource}`,
      data: record
    });
  };
};

const onEdit = (resource, record) => {
  return dispatch => {
    dispatch({
      type: `EDIT_${resource}`,
      data: record,
    });
  };
};

const onAdd = (resource) => {
  return dispatch => {
    dispatch({
      type: `ADD_${resource}`,
    });
  };
};

const onChange = (resource, field, data) => {
  return dispatch => {
    dispatch({
      type: `CHANGE_${resource}`,
      field: field,
      data: data
    });
  };
};

const save = ({resource, custom_action, http_method, data, successCallback}) => {
  const {id} = data;

  const isPut = id || http_method === 'PUT';

  const DISPATCH_TYPE = isPut
    ? `UPDATE_${resource}`
    : `CREATE_${resource}`;

  const HTTP_METHOD = isPut
    ? 'PUT'
    : 'POST';

  // save method for custom_action
  if (custom_action) return dispatch => {
      dispatch({type: `${DISPATCH_TYPE}_${custom_action}`, data: data});

      return ApiFactory.save(
        {
          resource,
          custom_action,
          HTTP_METHOD,
          data
        })
        .then(data => {
          dispatch({ type: `${DISPATCH_TYPE}_${custom_action}_SUCCESS`, data });
          successCallback(data);
        })
        .catch(err => {
          throw(err);
        });

  };

  // save method for standard resource
  return dispatch => {
    dispatch({type: DISPATCH_TYPE, data: data});

    return ApiFactory.save(
      {
        resource,
        HTTP_METHOD,
        data
      })
      .then(data => {
        dispatch({ type: `${DISPATCH_TYPE}_SUCCESS`, data });
        successCallback(data);
      })
      .catch(err => {
        throw(err);
      });

  };
};

const onDelete = ({resource, custom_action, id, successCallback}) => {
  const target = custom_action? `${resource}_${custom_action}` : `${resource}`;

  return dispatch => {
    dispatch({type: `DELETE_${target}`, id});
    return ApiFactory.delete({resource, id, custom_action})
    .then(data => {
      dispatch({ type: `DELETE_${target}_SUCCESS`, id });
      if(successCallback) {
        successCallback();
      }
    })
    .catch(err => {
      throw(err);
    });
  };
};

export default {
  get,
  select,
  onEdit,
  onAdd,
  onChange,
  save,
  onDelete
};



// WEBPACK FOOTER //
// ./src/action/ActionFactory.js